/**
 * The page `href` at the app's new address `domain`: protocol, port, path,
 * query and hash are kept, so an invite link or deep link survives a rename.
 * `null` when the page already is on `domain` (never redirect in a loop).
 */
export function movedAppUrl(href: string, domain: string): string | null {
  const url = new URL(href);
  if (url.hostname === domain.toLowerCase()) return null;
  url.hostname = domain;
  return url.toString();
}
